<template>
    <div class="upload1-wrapper">
        <a-upload
                accept=".jpeg,.jpg,.png,.gif,.bmp,.tiff,.tif,.webp,.svg,.ico,.raw,.mp4,.avi,.mov,.mkv,.wmv,.flv,.webm,.m4v,.3gp,.txt,.doc,.docx,.pdf,.xls,.xlsx,.csv,.zip,.rar,.7z"
                :disabled="isShow"
                :action="uploadUrl"
                :headers="uploadHeaders"
                :maxCount="count"
                list-type="picture-card"
                :file-list="ID_image"
                :before-upload="beforeUpload"
                @preview="handlePreview"
                @change="handleChange"
                name="file">
            <div v-if="ID_image.length < count">
                <a-icon type="plus" />
                <div class="ant-upload-text"></div>
            </div>
            <!-- 自定义每个文件卡片 -->
            <template v-if="false" slot="itemRender" />
        </a-upload>

        <!-- 自定义文件列表，替换默认卡片，加上类型角标 -->
        <div class="file-card-list">
            <div
                v-for="(file, index) in ID_image"
                :key="file.uid || index"
                class="file-card"
                :class="getFileClass(file)"
                @click="handlePreview(file)"
            >
                <!-- 图片：直接显示缩略图 -->
                <img
                    v-if="isImage(file)"
                    :src="file.url || file.thumbUrl || (file.response && file.response.data && file.response.data.file_url)"
                    class="file-thumb"
                />
                <!-- 非图片：显示类型图标 -->
                <div v-else class="file-icon-wrap">
                    <span class="file-ext-icon">{{ getExtLabel(file) }}</span>
                </div>
                <!-- 类型角标 -->
                <span class="file-badge" :class="getBadgeClass(file)">{{ getBadgeText(file) }}</span>
                <!-- 文件名 -->
                <div class="file-name">{{ getFileName(file) }}</div>
                <!-- 删除按钮 -->
                <a-icon
                    v-if="!isShow"
                    type="close-circle"
                    class="file-remove"
                    @click.stop="removeFile(index)"
                />
            </div>
        </div>

        <a-modal v-model="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="preview" style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>
</template>

<script>
    import Cookies from 'js-cookie';

    const IMAGE_EXTS = ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.tiff', '.tif', '.webp', '.svg', '.ico', '.raw'];
    const PDF_EXTS   = ['.pdf', '.txt'];
    const OFFICE_EXTS = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.csv'];

    const FILE_ICON_SVG = 'data:image/svg+xml;utf8,' + encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2340a9ff">' +
        '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
        '<polyline points="14 2 14 8 20 8" fill="white"/></svg>'
    );

    function ext(name) {
        if (!name) return '';
        const m = name.toLowerCase().match(/\.[^.]+$/);
        return m ? m[0] : '';
    }
    function isImageFile(name) { return IMAGE_EXTS.includes(ext(name)); }
    function isPdfFile(name)   { return PDF_EXTS.includes(ext(name)); }
    function isOfficeFile(name){ return OFFICE_EXTS.includes(ext(name)); }

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    export default {
        name: "index1",
        props: {
            ID_image: { type: Array, default: () => [] },
            count:    { type: Number, default: 1 },
            isShow:   { type: Boolean, default: false }
        },
        data() {
            return {
                uploadUrl: process.env.VUE_APP_NEW_URL + '/comapi/UploadApi',
                previewVisible: false,
                previewImage: '',
            }
        },
        computed: {
            uploadHeaders() {
                const token = Cookies.get('access');
                return token ? { Authorization: 'Bearer ' + token } : {};
            }
        },
        methods: {
            // ── 文件类型判断 ──────────────────────────────
            isImage(file) { return isImageFile(file.name || file.url || ''); },

            getFileName(file) {
                const name = file.name || file.url || '';
                return name.split('/').pop() || name;
            },

            getExtLabel(file) {
                const e = ext(file.name || file.url || '');
                return e ? e.replace('.', '').toUpperCase() : 'FILE';
            },

            // 卡片整体样式（悬停提示打开方式）
            getFileClass(file) {
                const name = file.name || file.url || '';
                if (isImageFile(name)) return 'type-image';
                if (isPdfFile(name))   return 'type-preview';
                if (isOfficeFile(name)) return 'type-download';
                return 'type-download';
            },

            // 角标文字
            getBadgeText(file) {
                const name = file.name || file.url || '';
                if (isImageFile(name)) return '预览';
                if (isPdfFile(name))   return '新窗口';
                return '下载';
            },

            // 角标颜色
            getBadgeClass(file) {
                const name = file.name || file.url || '';
                if (isImageFile(name)) return 'badge-image';
                if (isPdfFile(name))   return 'badge-preview';
                return 'badge-download';
            },

            // ── 上传前处理 ────────────────────────────────
            beforeUpload(file) {
                if (!isImageFile(file.name)) {
                    file.thumbUrl = FILE_ICON_SVG;
                }
                return true;
            },

            // ── 点击预览 ──────────────────────────────────
            async handlePreview(file) {
                const name = file.name || file.url || '';
                const url  = file.url
                    || (file.response && file.response.data && file.response.data.file_url)
                    || '';

                if (!isImageFile(name)) {
                    if (!url) return;
                    if (isPdfFile(name)) {
                        window.open(url, '_blank');
                        return;
                    }
                    // Office / zip 等：触发下载
                    try {
                        const res = await fetch(url);
                        const blob = await res.blob();
                        const blobUrl = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = blobUrl;
                        a.download = this.getFileName(file);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
                    } catch (e) {
                        window.open(url, '_blank');
                    }
                    return;
                }

                // 图片：弹窗预览
                if (!file.url && !file.preview) {
                    if (file.originFileObj instanceof Blob) {
                        file.preview = await getBase64(file.originFileObj);
                    } else if (file.response && file.response.data && file.response.data.file_url) {
                        file.preview = file.response.data.file_url;
                    } else {
                        return;
                    }
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },

            handleCancel() { this.previewVisible = false; },

            removeFile(index) {
                const newList = this.ID_image.filter((_, i) => i !== index);
                this.$emit('handleChange', newList);
            },

            handleChange({ fileList }) {
                this.$emit('handleChange', fileList);
            }
        }
    }
</script>

<style scoped>
.upload1-wrapper :deep(.ant-upload-list) {
    display: none; /* 隐藏默认列表，用自定义卡片替代 */
}

.file-card-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
}

.file-card {
    position: relative;
    width: 96px;
    height: 96px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    overflow: hidden;
    cursor: pointer;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s;
}
.file-card:hover { border-color: #1890ff; }

/* 图片卡片 */
.file-thumb {
    width: 100%;
    height: 68px;
    object-fit: cover;
}

/* 非图片图标区 */
.file-icon-wrap {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f7ff;
}
.file-ext-icon {
    font-size: 18px;
    font-weight: bold;
    color: #1890ff;
    letter-spacing: -1px;
}

/* 文件名 */
.file-name {
    width: 100%;
    padding: 2px 4px;
    font-size: 11px;
    color: #555;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: #fff;
    height: 28px;
    line-height: 24px;
}

/* 角标 */
.file-badge {
    position: absolute;
    top: 4px;
    left: 4px;
    font-size: 10px;
    padding: 1px 5px;
    border-radius: 3px;
    color: #fff;
    line-height: 16px;
}
.badge-image    { background: #52c41a; }  /* 绿：站内预览 */
.badge-preview  { background: #1890ff; }  /* 蓝：新窗口 */
.badge-download { background: #fa8c16; }  /* 橙：下载 */

/* 删除按钮 */
.file-remove {
    position: absolute;
    top: 4px;
    right: 4px;
    font-size: 16px;
    color: rgba(0,0,0,0.45);
    background: rgba(255,255,255,0.8);
    border-radius: 50%;
    display: none;
}
.file-card:hover .file-remove { display: block; }
.file-remove:hover { color: #ff4d4f; }
</style>
